import React from 'react';

import ReactFulcrumAuth from 'react-fulcrum-auth'
import FormSelect from './forms.js'
import BSTable from './table.js'

////////////////////////////////////////////////////////////////////

export default class FulcrumQuery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: "Codebookr",
      filename: undefined,
      forms: [],
      fulcrum: undefined,
      organization: undefined,
      rows: []
    };
  }

  componentDidMount() {
    //
  }

  componentWillUnmount() {
    //
  }

  setFulcrum = (fulcrum, org) => {
    var headers = new Headers({
      'Accept': "application/json",
      'Content-Type': "application/json",
      "X-ApiToken": sessionStorage.getItem("fulcrum_query_token")
    });
    fetch("https://api.fulcrumapp.com/api/v2/forms.json", {
      method: "GET",
      headers: headers
    }).then(function(res){
      return res.json();
    }).then(function(data){
      var forms = data.forms.map(function(d){
        return {id: d.id, name: d.name};
      }).sort(function(a,b){
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      });
      this.setState({
        forms: forms,
        fulcrum: fulcrum,
        organization: org,
        rows: []
      });
      this.refs.fs.resetSelect();
    }.bind(this)).catch(function(err){
      console.log("error", err);
    });
    // fulcrum.forms.search({}, function(error, data){
    //   if (error) {
    //     console.log("error", error);
    //     return;
    //   }
    //   var forms = data.forms.map(function(d){
    //     return {id: d.id, name: d.name};
    //   });
    //   this.setState({
    //     forms: forms,
    //     fulcrum: fulcrum,
    //     organization: org,
    //     rows: []
    //   });
    //   this.refs.fs.resetSelect();
    // }.bind(this));
  }

  setTableData = (rows, filename) => {
    this.setState({filename: filename, rows: rows})
  }

  render() {
    return (
      <div>
        <ReactFulcrumAuth appName={ this.state.appName } callback={ this.setFulcrum }></ReactFulcrumAuth>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h2>{ this.state.organization }</h2>
              <FormSelect ref="fs" forms={ this.state.forms } fulcrum={ this.state.fulcrum } setTableData={ this.setTableData }></FormSelect>
              <BSTable rows={ this.state.rows } filename={ this.state.filename }></BSTable>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/fulcrum_query.js